import React from "react";
import { Idea } from "../model/types";
import { IdeaActionButtons } from "./IdeaActionButtons";
import { PartnershipPreview } from "./PartnershipPreview";
import { RelatedCallCard } from "./RelatedCallCard";

interface IdeaSidebarProps {
  idea: Idea;
  user: any;
  userBasicInfo: any;
  isIdeaInRequests: boolean;
  isIdeaInInvitations: boolean;
  ideaActions: any;
}

export const IdeaSidebar: React.FC<IdeaSidebarProps> = ({
  idea,
  user,
  userBasicInfo,
  isIdeaInRequests,
  isIdeaInInvitations,
  ideaActions,
}) => {
  return (
    <>
      <PartnershipPreview idea={idea} />

      <IdeaActionButtons
        idea={idea}
        user={user}
        userBasicInfo={userBasicInfo}
        isIdeaInRequests={isIdeaInRequests}
        isIdeaInInvitations={isIdeaInInvitations}
        ideaActions={ideaActions}
      />

      {idea?.call && (
        <RelatedCallCard
          call={idea.call}
          userBasicInfo={userBasicInfo}
          onBookmark={() =>
            ideaActions.handleBookmarkCall(
              idea?.call?.id,
              idea.call?.is_call_bookmarked,
            )
          }
        />
      )}
    </>
  );
};
